/**
 * 계정 입력 규칙 — 서버 `apps/server/src/users/dto/create-user.dto.ts`와 동일 값.
 * 한쪽만 바꾸면 클라이언트 통과 후 서버 400이 나므로 양쪽을 같이 고친다.
 */

/** 로그인 ID 정책 — 영문·숫자 4~20자 (화면설계서 화면 2) */
export const LOGIN_ID_PATTERN = /^[A-Za-z0-9]{4,20}$/;
export const LOGIN_ID_MESSAGE = '로그인ID는 영문·숫자 4~20자입니다.';

/** 비밀번호 정책 — 공백 없이 영문·숫자·특수문자 포함 8자 이상 (공백은 특수문자로 인정하지 않는다) */
export const PASSWORD_PATTERN = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9\s])\S{8,}$/;
export const PASSWORD_MESSAGE = '비밀번호는 공백 없이 영문·숫자·특수문자 포함 8자 이상입니다.';
/** 서버 bcrypt 입력 상한과 동일 */
export const PASSWORD_MAX_LENGTH = 72;

export function isValidLoginId(value: string): boolean {
  return LOGIN_ID_PATTERN.test(value);
}

export function isValidPassword(value: string): boolean {
  return value.length <= PASSWORD_MAX_LENGTH && PASSWORD_PATTERN.test(value);
}
